import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { getClientsDatabyPaginationbySearch } from "../../../api/User/commonApi";

const ClientList = ({
  clientData,
  setClientData,
  customStyles,
  handleClientChange,
  selectedClientvalue,
  setSelectedClientValue
}) => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  useEffect(() => {
    if (client !== null && client?.client !== 0)
      setSelectedClientValue({
        value: client?.clientID,
        label: client?.clientName,
      });
    else
      setSelectedClientValue({
        value: 0,
        label: "SELECT CLIENT NAME",
      });
  }, []);
  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientID,
          label: port.clientName,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };
  return (
    <AsyncPaginate
      value={selectedClientvalue || null}
      loadOptions={loadOptions}
      styles={customStyles}
      placeholder="SELECT CLIENT NAME"
      onChange={handleClientChange}
      isSearchable={true}
      additional={{
        page: 1,
      }}
      debounceTimeout={2500}
      menuPlacement="auto"
      isOptionDisabled={(e) => e.value === 0}
      />
  );
};

export default ClientList;
